import React from "react";
import { OvalNeumorphicBtn } from "../../buttons";
import { XIcon, LeftArrowIcon } from "../../../components/icons/index";
import "./modalControlRouterWrapper.scss";

const ModalControlRouterWrapper = ({ 
  title, 
  onBack, 
  onCancel, 
  icon, 
  children,
  titleIconClassName,
  titleClassName,
  wrapperClassName,
  overlayClassName,
  isCheckout,
}) => {

  const fullOverlayClassName = `campaign-form-modal-overlay ${overlayClassName} ${
    isCheckout ? "checkout-modal" : ""
  }`; 

  return (
    <div className={fullOverlayClassName}>
      <div className={`campaign-form-modal-content ${wrapperClassName}`}>
        <div className="campaign-form-modal-header">
          {onBack && ( // setting the onback to a conditional prop to control visiblity. I had to nest the modal for a conditional form where the back button is not shown in the first step form, see admanager dasboard to understand visiblity
            <OvalNeumorphicBtn
              onClick={onBack}
              icon={
                <LeftArrowIcon
                  width="15"
                  height="15"
                  fillColor="var(--color-gold)"
                  style={{ paddingRight: "5px" }}
                />
              }
              text="Back"
              fontSize="18px"
              fontFamily="Roboto, sans-serif"
              fontWeight="bold"
            />
          )}
         <div className={`campaign-form-modal-title-icon-wrapper ${titleIconClassName || ''}`}>
            {icon && <span className="campaign-form-modal-icon">{icon}</span>}
            <h1 className={`campaign-form-modal-title ${titleClassName}`}>{title}</h1>
          </div>
          <OvalNeumorphicBtn
            onClick={onCancel}
            icon={
              <XIcon
                width="15"
                height="15"
                fillColor="var(--color-gold)"
                style={{ paddingRight: "5px" }}
              />
            }
            text="Cancel"
            fontSize="18px"
            fontFamily="Roboto, sans-serif"
            fontWeight="bold"
          />
        </div>
        <div className="campaign-form-modal-body">{children}</div>
      </div>
    </div>
  );
};

export default ModalControlRouterWrapper;
